module.exports = __webpack_public_path__ + "static/media/ETHs.946772ab.svg";